export default "__VITE_ASSET__Bn$FrCFv__"